import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1a3a4a] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/8e384c9bc7f8801e8dfb8b46c454c1a0/8f67fa6b32841b5133bde974ef05cb2d.png"
              alt="JampaBit Informática"
              className="h-16 md:h-24 w-auto object-contain mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-5">
              Assistência técnica especializada para residências e empresas em João Pessoa e região. Confiança e qualidade em cada atendimento.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://wa.me/5583991755663"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#00c9a7] transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-base" />
              </a>
              <a
                href="https://www.instagram.com/jampabit/"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#00c9a7] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-base" />
              </a>
              <a
                href="mailto:jampabit@gmail.com"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#00c9a7] transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-base" />
              </a>
            </div>
          </div>

          {/* Serviços */}
          <div>
            <h4 className="text-sm font-semibold text-[#00c9a7] uppercase tracking-wider mb-4 md:mb-5">
              <a href="/servicos">Serviços</a>
            </h4>
            <ul className="space-y-2.5 md:space-y-3">
              {[
                'Formatação de Micros e Notebooks',
                'Montagem de Computadores Gamers',
                'Limpeza e Manutenção',
                'Suporte Remoto',
                'Instalação de Softwares',
                'Criação de Sites',
              ].map((s) => (
                <li key={s}>
                  <Link to="/servicos" className="text-white/60 text-sm hover:text-[#00c9a7] transition-colors cursor-pointer">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Atendimento */}
          <div>
            <h4 className="text-sm font-semibold text-[#00c9a7] uppercase tracking-wider mb-4 md:mb-5">
              <a href="/sobre">Atendimento</a>
            </h4>
            <ul className="space-y-2.5 md:space-y-3">
              {[
                { label: 'Pessoa Física', path: '/servicos' },
                { label: 'Pessoa Jurídica', path: '/servicos' },
                { label: 'Atendimento no Local', path: '/contato' },
                { label: 'Suporte Remoto', path: '/servicos' },
                { label: 'Solicitar Orçamento', path: '/contato' },
                { label: 'Perguntas Frequentes', path: '/faq' },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="text-white/60 text-sm hover:text-[#00c9a7] transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="text-sm font-semibold text-[#00c9a7] uppercase tracking-wider mb-4 md:mb-5">
              <a href="/contato">Contato</a>
            </h4>
            <ul className="space-y-3 md:space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-[#00c9a7] text-base" />
                </div>
                <span className="text-white/60 text-sm">João Pessoa, Paraíba - Atendimento a domicílio</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-[#00c9a7] text-base" />
                </div>
                <a href="https://wa.me/5583991755663" className="text-white/60 text-sm hover:text-[#00c9a7] transition-colors cursor-pointer">
                  (83) 9 9175-5663
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-[#00c9a7] text-base" />
                </div>
                <a href="mailto:jampabit@gmail.com" className="text-white/60 text-sm hover:text-[#00c9a7] transition-colors cursor-pointer">
                  jampabit@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-[#00c9a7] text-base" />
                </div>
                <span className="text-white/60 text-sm">Seg–Sex: 8h–18h<br />Sáb: 8h–13h</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 md:mt-12 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs text-center sm:text-left">
            &copy; {new Date().getFullYear()} JampaBit Informática. Todos os direitos reservados.
          </p>
          <p className="text-white/40 text-xs">
            Assistência técnica em João Pessoa, PB
          </p>
        </div>
      </div>
    </footer>
  );
}
